



























































































import { Component, Vue } from 'vue-property-decorator';
import { LicenseDataEditModel, PaymentAmountModel } from "@/services/api/nswag/stapiclient_generated";
import { stAccountApi } from '@/services/st-api';
import StRatePicker from '@/components/basic/StRatePicker.vue';
import SlideIn from '@/components/basic/SlideIn.vue';
import StInput2 from '@/components/basic/StInput2.vue';
import StToggle from '@/components/basic/StToggle.vue';
import StTextarea from '@/components/basic/StTextarea.vue';
import { notifyError, notifySuccess } from '@/utlitities/notifications';
import StCurrencyInput from "@/components/basic/StCurrencyInput.vue";
import { formatCentToEuro, formatDate } from "@/utlitities/helper";
import { UserStore } from "@/store/user-module";

@Component({
  components: {
    StCurrencyInput,
    StTextarea,
    StToggle,
    StInput2,
    SlideIn,
    StRatePicker,
  },
})
export default class EditLicenseData extends Vue {
  licenseData: LicenseDataEditModel = LicenseDataEditModel.fromJS({});
  loading: boolean = true;
  listPage: string = 'Payment';
  initialUserCount: number = 0;
  newAmountModel: PaymentAmountModel = PaymentAmountModel.fromJS({});
  delayLoading = false;
  saving = false;
  amountModelLoaded= false;

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  formatDate(val: any){
    return formatDate(val);
  }

  centToEuro(val: number){
    return formatCentToEuro(val);
  }

  get usePassiveUsers(){
    return UserStore.userSettings.featureFlagPassiveUsers;
  }

  get showBasicUserInputs(){
    return (UserStore.userSettings.featureFlagPassiveUsers || UserStore.userSettings.featureFlagMixedUsers) && !UserStore.userSettings.useBasicTimeTracking
  }

  get addedUserCount(){
    const res = this.licenseData.userCount! - this.licenseData.payedUserCount!;
    return res > 0 ? res : 0;
  }

  get addedUserCountBasic(){
    const res = this.licenseData.userCountBasic! - this.licenseData.payedUserCountBasic!;
    return res > 0 ? res : 0;
  }

  async loadAmountModel(){
    try {
      this.delayLoading = true;
      if (this.addedUserCount > 0 || this.addedUserCountBasic > 0) {
        this.newAmountModel = await stAccountApi.calculateNewAmount(this.addedUserCount, this.addedUserCountBasic);
        this.amountModelLoaded = true;
      } else {
        this.newAmountModel = PaymentAmountModel.fromJS({});
        this.amountModelLoaded = false;
      }
    } finally {
      this.delayLoading = false;
    }
  }

  async mounted() {
    this.openSlideIn();

    this.licenseData = await stAccountApi.getLicenseDataEditModel();
    this.initialUserCount = this.licenseData.userCount ?? 0;
    this.loading = false;
  }

  async submit() {
    try {
      this.saving = true;
      this.licenseData.isUserCountUpdate = true;
      await stAccountApi.saveLicenseData(this.licenseData);
      notifySuccess("Erfolgreich gespeichert");
      this.closeSlideIn();
    } finally {
      this.saving = false;
    }
  }
}
